import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { investItem, investOpenType } from "./investConst";
import investStock from "./investStock";

const {ccclass, property} = cc._decorator;

@ccclass
export default class kLineNode extends cc.Component {

    @property({type:cc.Graphics,displayName:"绘制组件"})
    private graphics:cc.Graphics = null;

    @property({type:cc.Node,displayName:"mask节点"})
    private maskNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    explainLb:cc.Label = null;

    @property({type:cc.Node,displayName:"补仓按钮"})
    addBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"icon节点"})
    iconNode:cc.Node = null;

    private investStock:investStock = null;

    private pointCountAry:number[][] = [[1,2],[3,6],[7,10]];
    private pointCountWeightAry:number[] = [5,70,25];

    private riseRadioAry:number[][] = [[0.1,0.2],[0.2,0.5],[0.5,0.8],[0.8,1],[1,1.2],[1.2,1.5]];
    private riseRadioWeightAry:number[] = [60,20,10,5,3,2];

    private reduceRadioAry:number[][] = [[0.1,0.2],[0.2,0.5],[0.5,0.8],[0.8,1],[1,1.2],[1.2,1.5]];
    private reduceRadioWeightAry:number[] = [60,20,10,5,3,2];

    private lastRadio:number = 0;

    //绑定数据
    bindData(investStock:investStock){
        this.investStock = investStock;
        this.updateAddBtn();
    }

    //加载绘制的线
    loadStroke(){
        this.loadIcon();
        this.graphics.clear();
        this.maskNode.width = 0;
        let strokeCountIndex = data_control.getRandIPosByWeights(this.pointCountWeightAry);
        let pointCountAry:number[] = this.pointCountAry[strokeCountIndex].concat();
        let pointCount:number = Math.round(data_control.getRandNumberOfArrayTwo(pointCountAry));
        let radioAry:number[] = [-1.5,1.5];
        let nowRadio:number = 0;

        let rand = Math.random();

        let isRise:boolean = rand < gameConfig.INVEST_RISE_PRO;
        let lastRadio:number = 0;
        if(isRise){
            let randIndex:number = data_control.getRandIPosByWeights(this.riseRadioWeightAry);
            let rAry:number[] = this.riseRadioAry[randIndex];
            lastRadio = Number(data_control.getRandNumberOfArrayTwo(rAry).toFixed(2));
        }else{
            let randIndex:number = data_control.getRandIPosByWeights(this.reduceRadioWeightAry);
            let rAry:number[] = this.reduceRadioAry[randIndex];
            lastRadio = - Number( (data_control.getRandNumberOfArrayTwo(rAry)).toFixed(2));
        }
        switch(this.investStock.openType){
            case investOpenType.driftBottle:{
                if(this.investStock.currentSelectItem.id == this.investStock.driftBottleObjID.toString()){
                    let randIndex:number = data_control.getRandIPosByWeights(this.riseRadioWeightAry);
                    let rAry:number[] = this.riseRadioAry[randIndex];
                    lastRadio = Number(data_control.getRandNumberOfArrayTwo(rAry).toFixed(2));
                }
                break;
            }
        }
        this.lastRadio = lastRadio;
        let radios:number[] = [];
        let radioXAry:number[] = [];
        let residueXRadio:number = 0.4;
        let minRadio:number = (1-residueXRadio) / (pointCount + 1);
        let nowRadioX:number = 0;
        for(let i =0;i<pointCount;i++){
            let isRise:boolean = Math.random() < 0.5;
            let radio:number = 0;
            if(isRise){
                radio = data_control.getRandNumberOfArrayTwo([nowRadio,radioAry[1]]);
                radio = Number(radio.toFixed(1));
            }else{
                radio = data_control.getRandNumberOfArrayTwo([radioAry[0],nowRadio]);
                radio = Number(radio.toFixed(1));
            }
            nowRadio = radio;
            radios.push(nowRadio);

            //X坐标校正
            let randRadio = data_control.getRandNumberOfArrayTwo([0,residueXRadio]);
            let r = minRadio + randRadio;
            residueXRadio -= randRadio;
            nowRadioX += r;
            radioXAry.push(nowRadioX);
        }

        let maxX:number = 500;
        let maxY:number = 160;
        let nowX:number = 0;
        let nowY:number = 0;
        for(let i =0; i < pointCount + 1; i++){
            let radioY:number = radios[i];
            let radioX:number = radioXAry[i];

            let xPos:number = null;
            let yPos:number = null;
            if(radioX != null && radioY != null){
                xPos = maxX * radioX;
                yPos = maxY * radioY;

            }else{
                yPos = maxY * lastRadio;
                xPos = maxX;
            }
            this.graphics.moveTo(nowX,nowY);
            this.graphics.lineTo(xPos,yPos);
            this.graphics.stroke();

            nowX = xPos;
            nowY = yPos;
        }
        this.startStorke();
    }

    startStorke(){
        this.canClick = false;
        return new Promise<number>(resolve=>{
            cc.tween(this.maskNode).to(5,{width:550}).start();
            this.scheduleOnce(()=>{
                resolve(this.lastRadio);
            },5);
        });
    }

    updateExplain(explain:string){
        return new Promise<void>(async resolve=>{
            let s:string = "";
            this.explainLb.string = "";
            for(let i = 0;i<explain.length;i++){
                s+= explain[i];
                this.explainLb.string = s;
                await new Promise<void>(res=>{
                    this.scheduleOnce(res,.05);
                });
            }
            this.canClick = true;
            resolve();
        });
    }

    canClick:boolean = true;

    onBtnSell(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(!this.canClick){
            return;
        }
        this.investStock.onSell();
    }

    onBtnAdd(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(!this.canClick){
            return;
        }
        if(this.addIsVideo){
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.investStock.startPrice();
            },()=>{},null,"看视频补仓");
        }else{
            this.investStock.startPrice();
        }
    }

    addIsVideo:boolean = false;

    updateAddBtn(){
        let layout = this.addBtn.getChildByName("layout");
        let video:cc.Node = layout.getChildByName("video");
        if(this.investStock.m_roundsInCome.length >= 2){
            video.active = true;
            this.addIsVideo = true;
        }else{
            video.active = false;
            this.addIsVideo = false;
        }

    }

    loadIcon(){
        if(this.investStock.currentSelectItem){
            let spPath = this.investStock.currentSelectItem.icon;
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle);
            bundle.load(`assets/obj/${spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.debug("加载物品图片失败");
                    return;
                }
                this.iconNode.getComponent(cc.Sprite).spriteFrame = asset;
            });
        }
    }

}
